import styled from 'styled-components';
import { EllipsisTooltip } from '@components/common';
import { Space } from 'antd';

export const StyledEllipsisTooltip = styled(EllipsisTooltip)`
  font-size: 1.8em;
`;

export const ScopeWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
`;

export const IconWrap = styled(Space)`
  font-size: 1.8em;

  .ant-space-item {
    display: inline-flex;
  }
`;

export const Span = styled.div`
  width: 1em;
`;

export const BaseTile = styled.span`
  display: inline-block;
  width: 140px;
  height: 46px;
  cursor: pointer;
  position: relative;
  padding-right: 10px;
  border-radius: 6px;
  line-height: 41px;
`;

export const GoodTile = styled(BaseTile)`
  background-color: #f6f6f6;
  border: 2px solid #f6f6f6;
  color: #686868;

  &:hover {
    background-color: rgb(234 234 234);
    border: 2px solid rgb(218 218 218);
    color: rgb(74 74 74);
  }
`;

export const WarningTile = styled(BaseTile)`
  background-color: #fff;
  border: 2px solid #f99838;
  color: #686868;

  &:hover {
    background-color: rgb(255 147 0 / 40%);
    border: 2px solid #f99838;
    color: #4a4a4a;
  }
`;

export const CriticalTile = styled(BaseTile)`
  background-color: rgb(236 15 15 / 60%);
  border: 2px solid #d0021b;
  color: #fff;

  &:hover {
    background-color: rgb(236 15 15 / 80%);
    border: 2px solid rgb(208 2 27);
    color: rgb(255 255 255);
  }
`;

export const RealtimeTileValue = styled.span`
  font-size: 28px;
  font-weight: 500;
  float: right;
`;

export const RealtimeTileUnit = styled.span`
  margin-left: 4px;
  font-size: 18px;
  font-weight: 400;
  float: right;
  line-height: 48px;
`;
